import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Header({ children }) {

    const { user } = useSelector(state => state.user);

    return (
        <Container className="d-none d-lg-block">
            <Row className="mt-3">
                <div className="d-flex align-items-end gap-3">
                    <div>
                        <Link to="/" className="d-block text-md-start text-center">
                            <img className="main-logo" src="/images/logo.png" style={{ marginTop: "-30px" }} />
                        </Link>
                    </div>
                    {children}
                    <div className="">
                        <Link to={user ? "/account" : "/login"}>
                            <img src="/icons/profile.svg" />
                        </Link>
                    </div>
                </div>
            </Row>
        </Container>
    )
}